import CoverApi from './CoverApi';

export const coverApi = new CoverApi(process.env.REACT_APP_BASE_URL as any);
